var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetBreak300124(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#212121",
    strokeWidth: 1.167
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.74 6c4.746 0 8.593 3.876 8.593 8.657a8.669 8.669 0 0 1-1.068 4.184l-7.224-4.017a.583.583 0 0 1-.3-.51V6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.926 7.353v7.97c0 .424.23.814.6 1.02l6.924 3.85c-1.464 2.668-4.285 4.474-7.524 4.474-4.746 0-8.593-3.876-8.593-8.657 0-4.781 3.847-8.657 8.593-8.657z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetBreak300124);
export default __webpack_public_path__ + "static/media/set-break_30_01_24.090381a9ae53bc7b13245f029a8a1d0c.svg";
export { ForwardRef as ReactComponent };